export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4 md:mb-5">
              关于韩漫屋
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                韩漫屋是一个专注韩国漫画资源整合的在线阅读平台，致力于为广大韩漫爱好者提供最全面的韩漫全集免费阅读体验。从经典老番到当季新作，我们收录了超过5000部高质量韩漫作品，涵盖恋爱、奇幻、悬疑、动作、校园、古风、都市等十余个题材分类。
              </p>
              <p>
                平台坚持每日同步更新策略，确保热门连载的韩漫免费全集在线内容始终与韩国本土更新节奏保持一致。我们的团队持续追踪各大韩漫平台的最新动态，第一时间将最新话呈现在读者面前，让追更不再煎熬等待。
              </p>
              <p>
                韩漫屋采用高清原画级画质呈现，配合流畅的下拉式阅读体验，充分尊重韩漫特有的纵向分镜叙事风格。无需注册登录，打开即看，全章节免费开放，让每一位韩漫读者都能纯粹享受阅读的乐趣。
              </p>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[440px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20a%20digital%20tablet%20displaying%20colorful%20Korean%20manhwa%20webtoon%20art%2C%20warm%20ambient%20lighting%20from%20a%20desk%20lamp%2C%20soft%20cream%20and%20coral%20color%20palette%2C%20comfortable%20modern%20interior%2C%20artistic%20lifestyle%20photography%2C%20clean%20minimal%20composition%2C%20inviting%20atmosphere&width=880&height=660&seq=about-platform&orientation=landscape"
                alt="关于韩漫屋 - 平台阅读体验展示"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}